import { Component, Input } from '@angular/core';
import { combineInput } from '@app/new-ui/analysis/analysis.component';
import { generateOversizeCountTimelineChartLines } from '@app/new-ui/chart-transforms';
import { op } from '@lib/rxjs';
import { BehaviorSubject, combineLatest, firstValueFrom, Observable } from 'rxjs';
import { FragQueryService } from 'src/injectables/frag-query.service';
import * as Highcharts from 'highcharts/highstock';
import { DateTime } from '@lib/date-time';

@Component({
    selector: 'oversize-rockcount-timeline-page',
    templateUrl: './oversize-rockcount-timeline-page.component.html',
    styleUrls: ['./oversize-rockcount-timeline-page.component.scss']
})
export class OversizeRockcountTimelinePageComponent {
    constructor(public fragQuery: FragQueryService) { }

    @Input() startDate: DateTime;
    @Input() endDate: DateTime;

    public Highcharts: typeof Highcharts = Highcharts;
    public readonly chartType$ = this.fragQuery.chartType$;
    public readonly currentInterval = new BehaviorSubject(null);

    private addData(type: string) {
        this.fragQuery.addDataAt.next(type);
    }

    private async onPlotClick(time: number) {
        const input = await firstValueFrom(
            this.fragQuery.timelineSieveSizesAtPercents$
        );
        let dataPoint;
        for (let index = 0; index < input.intervals.length; index++) {
            const interval = input.intervals[index];
            if (interval.begin.valueOf() <= time) {
                dataPoint = interval;
            } else {
                break;
            }
        }
        if (dataPoint) {
            this.currentInterval.next(dataPoint);
        }
    }

    public readonly oversizeRockChartLines$: Observable<Highcharts.Options> = combineLatest([
        this.fragQuery.timelineSieveSizesAtPercents$,
        this.fragQuery.addOnTimelineSieveSizesAtPercents$,
    ]).pipe(
        op.tap(([input, addOn]) => combineInput(input, addOn, this.fragQuery.addDataAt.value)),
        op.map(([input]) => generateOversizeCountTimelineChartLines('line', input, this.addData.bind(this), this.onPlotClick.bind(this), `Oversize Rock Count`, true, true, true, true))
    );

    public readonly oversizeRockChartSeries$: Observable<Highcharts.Options> = combineLatest([
        this.fragQuery.timelineSieveSizesAtPercents$,
        this.fragQuery.addOnTimelineSieveSizesAtPercents$,
    ]).pipe(
        op.tap(([input, addOn]) => combineInput(input, addOn, this.fragQuery.addDataAt.value)),
        op.map(([input]) => generateOversizeCountTimelineChartLines('series', input, this.addData.bind(this), this.onPlotClick.bind(this), `Oversize Rock Count`, true, true, true, true))
    );
}